import {AdvanceSaleRequiredProductGroup, ExtraPoints} from "./action-points-configuration.model";

export class ActionPointsAdvanceSaleResult {
    private _closeDialog: boolean;
    private _success : boolean;
    private _campaignSequence: number;
    private _message : string;

    constructor( closeDialog, success=true, campaignSequence = undefined, message = '[Empty Message]'){
        this._closeDialog = closeDialog;
        this._success = success;
        this._campaignSequence = campaignSequence;
        this._message = message;
    }

    public isSuccess() : boolean {
        return this._success;
    }

    public getSequence() : number {
        return this._campaignSequence;
    }

    public getMessage() : string {
        return this._message;
    }

    public isCloseDialog(): boolean {
        return this._closeDialog;
    }
}

export class ActionPointsExtraPointsResult {
    private _closeDialog: boolean;
    private _success : boolean;
    private _extraPoint: ExtraPoints | undefined;
    private _message : string;

    constructor( closeDialog, success=true, extraPoint = undefined, message = '[Empty Message]'){
        this._closeDialog = closeDialog;
        this._success = success;
        this._extraPoint = extraPoint;
        this._message = message;
    }

    public isSuccess() : boolean {
        return this._success;
    }

    public getExtraPoint() : ExtraPoints {
        return this._extraPoint;
    }

    public getMessage() : string {
        return this._message;
    }

    public isCloseDialog(): boolean {
        return this._closeDialog;
    }
}

export class ActionPointsRequiredGroupResult {
    private _closeDialog: boolean;
    private _success : boolean;
    private _requiredGroup: AdvanceSaleRequiredProductGroup | undefined;
    private _message : string;

    constructor( closeDialog, success=true, requiredGroup = undefined, message = '[Empty Message]'){
        this._closeDialog = closeDialog;
        this._success = success;
        this._requiredGroup = requiredGroup;
        this._message = message;
    }

    public isSuccess() : boolean {
        return this._success;
    }

    public getRequiredGroup() : AdvanceSaleRequiredProductGroup {
        return this._requiredGroup;
    }

    public getMessage() : string {
        return this._message;
    }

    public isCloseDialog(): boolean {
        return this._closeDialog;
    }
}
